import { Component } from '@angular/core';
import {NavParams, AlertController, ViewController} from "ionic-angular";
import * as firebase from 'firebase/app';
import {Params} from "../../params";

/**
 * Generated class for the LocationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

declare var google;

@Component({
  selector: 'page-location',
  templateUrl: 'location.html',
})
export class LocationPage {
  customer;
  map = null;
  constructor(
    public viewCtrl: ViewController,
    public params: NavParams,
    public alertCtrl: AlertController
  ) {
    this.customer = this.params.get("user");
    console.log('customer', this.customer);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LocationPage');
    const mapProp = {
      center: new google.maps.LatLng(this.customer.location.lat, this.customer.location.lng),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    };

    this.map = new google.maps.Map(document.querySelector('#map'), mapProp);
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(this.customer.location.lat, this.customer.location.lng),
      map: this.map,
      animation: google.maps.Animation.DROP,
      draggable: true
    });

    google.maps.event.addListener(marker, 'dragend', (event) => {
      let confirm = this.alertCtrl.create({
        title: 'Confirmar',
        message: '¿Está seguro de cambiar las coordenadas a esta nueva ubicación?',
        buttons: [
          {
            text: 'Cancelar',
            handler: () => {
              console.log('Disagree clicked');
            }
          },
          {
            text: 'Si, deseo modificarla',
            handler: () => {
              let code = Params.md5(this.customer.email);
              firebase.database().ref('customers/'+code).update({
                location:{
                  lat: event.latLng.lat(),
                  lng: event.latLng.lng()
                }
              }).then(_ => {
                this.viewCtrl.dismiss();
              });
            }
          }
        ]
      })
      confirm.present();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/customers/location/location.ts